import React, { useEffect, useState } from 'react';

const apiUrl = process.env.REACT_APP_API_URL;

const CastronegroVotos = () => {
    const [players, setPlayers] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [myActions, setMyActions] = useState<{action: string, target: string}[]>([]);
    const [voteError, setVoteError] = useState("");
    const [showRules, setShowRules] = useState(false);

    const [myQr, setMyQr] = useState<string | null>(null);

    useEffect(() => {
        const storedQr = localStorage.getItem('castronegro_my_qr');
        setMyQr(storedQr);

        const fetchPlayersAndVotes = async () => {
            try {
                const [playersRes, votesRes] = await Promise.all([
                    fetch(`${apiUrl}:8061/cluedo/players`),
                    fetch(`${apiUrl}:8061/cluedo/votes`)
                ]);

                if (playersRes.ok) {
                    const data = await playersRes.json();
                    const alivePlayers = data.filter((p: any) => !p.titol?.startsWith('X '));
                    setPlayers(alivePlayers);
                }

                if (votesRes.ok) {
                    const voteData = await votesRes.json();
                    if (storedQr) {
                        const raw = voteData.rawVotes || [];
                        const actions = raw
                            .filter((r: string) => r.startsWith(storedQr + "|"))
                            .map((r: string) => {
                                const parts = r.split("|");
                                return {
                                    target: parts[1],
                                    action: parts.length >= 3 ? parts[2] : "NORMAL"
                                };
                            });
                        setMyActions(actions);
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPlayersAndVotes();
    }, []);

    const isCompleted = () => {
        if (!myQr) return false;
        const actionNames = myActions.map(a => a.action);
        if (myQr === 'PER001') return actionNames.includes('SALVAR') && actionNames.includes('MATAR');
        if (myQr === 'PER100') return actionNames.filter(a => a === 'MATAR_LOBO').length >= 2;
        if (myQr === 'PER102') return actionNames.includes('MATAR') && actionNames.includes('ANULAR');
        return actionNames.includes('NORMAL');
    };

    const hasVoted = isCompleted();

    const handleVote = async (qr: string, title: string, action: string = 'NORMAL') => {
        if (hasVoted) return;
        
        let confirmText = `votar por ${title}`;
        if (action !== 'NORMAL') confirmText = `${action.toLowerCase()} a ${title}`;
        
        const confirmVote = window.confirm(`¿Estás seguro de que quieres ${confirmText}? No podrás cambiar tu decisión.`);
        if (!confirmVote) return;

        try {
            const response = await fetch(`${apiUrl}:8061/cluedo/vote`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ voter_qr: myQr, voted_qr: qr, action: action }),
            });

            if (response.ok) {
                setMyActions(prev => [...prev, { action: action, target: qr }]);
            } else {
                setVoteError("Error al registrar el voto. Inténtalo de nuevo.");
            }
        } catch (error) {
            console.error('Error submitting vote:', error);
            setVoteError("Error de conexión al votar.");
        }
    };

    const renderButtons = (player: any) => {
        const hasAction = (act: string) => myActions.some(a => a.action === act);
        const hasActionOnPlayer = (act: string, targetQr: string) => myActions.some(a => a.action === act && a.target === targetQr);

        if (myQr === 'PER001') {
            return (
                <div style={{ display: 'flex', gap: '10px', width: '100%', marginTop: '15px' }}>
                    {!hasAction('SALVAR') && (
                        <button onClick={(e) => { e.stopPropagation(); handleVote(player.qr_code, player.titol, 'SALVAR'); }} style={{ flex: 1, backgroundColor: '#2e7d32', color: 'white', padding: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>SALVAR</button>
                    )}
                    {!hasAction('MATAR') && (
                        <button onClick={(e) => { e.stopPropagation(); handleVote(player.qr_code, player.titol, 'MATAR'); }} style={{ flex: 1, backgroundColor: '#8b0000', color: 'white', padding: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>MATAR</button>
                    )}
                </div>
            );
        }
        if (myQr === 'PER100') {
            if (hasActionOnPlayer('MATAR_LOBO', player.qr_code)) {
                return (
                    <div style={{ width: '100%', marginTop: '15px', backgroundColor: '#3a0000', color: '#ff4c4c', padding: '12px', border: '1px solid #ff4c4c', borderRadius: '4px', textAlign: 'center', fontWeight: 'bold', fontSize: '1rem' }}>
                        💀 MARCADO
                    </div>
                );
            }
            return (
                <button onClick={(e) => { e.stopPropagation(); handleVote(player.qr_code, player.titol, 'MATAR_LOBO'); }} style={{ width: '100%', marginTop: '15px', backgroundColor: '#8b0000', color: 'white', padding: '12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>MATAR (LOBO)</button>
            );
        }
        if (myQr === 'PER102') {
            return (
                <div style={{ display: 'flex', gap: '10px', width: '100%', marginTop: '15px' }}>
                    {!hasAction('MATAR') && (
                        <button onClick={(e) => { e.stopPropagation(); handleVote(player.qr_code, player.titol, 'MATAR'); }} style={{ flex: 1, backgroundColor: '#8b0000', color: 'white', padding: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>MATAR</button>
                    )}
                    {!hasAction('ANULAR') && (
                        <button onClick={(e) => { e.stopPropagation(); handleVote(player.qr_code, player.titol, 'ANULAR'); }} style={{ flex: 1, backgroundColor: '#f39c12', color: '#111', padding: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>ANULAR VOTO</button>
                    )}
                </div>
            );
        }
        return (
            <button
                onClick={(e) => { e.stopPropagation(); handleVote(player.qr_code, player.titol, 'NORMAL'); }}
                style={{
                    marginTop: '15px', padding: '12px', backgroundColor: '#8b0000', color: 'white',
                    border: '1px solid #ff4c4c', borderRadius: '4px', fontWeight: 'bold', fontSize: '1.1rem',
                    cursor: 'pointer', width: '100%', textTransform: 'uppercase'
                }}
            >
                Votar por {player.titol}
            </button>
        );
    };

    return (
        <div style={{
            backgroundColor: '#121212',
            color: '#e0e0e0',
            minHeight: '100vh',
            fontFamily: '"Georgia", "Times New Roman", serif',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxSizing: 'border-box'
        }}>
            <h1 style={{ color: '#8b0000', fontSize: '3rem', textTransform: 'uppercase', textShadow: '2px 2px 5px rgba(139,0,0,0.5)', textAlign: 'center', marginBottom: '10px' }}>
                La Asamblea del Pueblo
            </h1>
            <p style={{ fontSize: '1.2rem', marginBottom: '15px', textAlign: 'center', color: '#aaa' }}>
                Es hora de decidir quién será ejecutado. Vota sabiamente.
            </p>

            <button 
                onClick={() => setShowRules(true)}
                style={{ marginBottom: '30px', padding: '10px 20px', backgroundColor: '#8b4513', color: '#fff', border: '1px solid #dba766', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1rem' }}
            >
                📜 Ver Reglas de los Roles
            </button>

            {voteError && (
                <div style={{ backgroundColor: 'rgba(255,0,0,0.2)', color: '#ff4c4c', padding: '10px', borderRadius: '5px', marginBottom: '20px', border: '1px solid #ff4c4c' }}>
                    {voteError}
                </div>
            )}

            {!myQr ? (
                <div style={{
                    backgroundColor: '#1a1a1a',
                    border: '2px solid #8b4513',
                    borderRadius: '8px',
                    padding: '40px',
                    textAlign: 'center',
                    maxWidth: '600px',
                    boxShadow: '0 0 20px rgba(139,69,19,0.4)'
                }}>
                    <h2 style={{ color: '#f4e4bc', fontSize: '2rem' }}>Identificación Necesaria</h2>
                    <p style={{ fontSize: '1.2rem', marginTop: '20px', color: '#ccc' }}>Debes escanear tu ficha de personaje primero y hacer clic en el botón de votar desde tu perfil.</p>
                </div>
            ) : hasVoted ? (
                <div style={{
                    backgroundColor: '#1a1a1a',
                    border: '2px solid #8b0000',
                    borderRadius: '8px',
                    padding: '40px',
                    textAlign: 'center',
                    maxWidth: '600px',
                    boxShadow: '0 0 20px rgba(139,0,0,0.4)'
                }}>
                    <h2 style={{ color: '#ff4c4c', fontSize: '2.5rem' }}>Voto Registrado</h2>
                    <p style={{ fontSize: '1.2rem', marginTop: '20px' }}>Tu decisión ha sido tomada. Ahora solo queda esperar el resultado de la asamblea...</p>
                </div>
            ) : loading ? (
                <div style={{ fontSize: '1.5rem', color: '#8b0000' }}>Cargando supervivientes...</div>
            ) : players.length === 0 ? (
                <div style={{ fontSize: '1.5rem', color: '#ff4c4c', textAlign: 'center', padding: '20px' }}>
                    No se han encontrado personajes vivos en la base de datos.<br />
                    Asegúrate de que haya registros con qr_code que empiecen por "PER" y no estén muertos ("X " en el título).
                </div>
            ) : (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                    gap: '20px',
                    width: '100%',
                    maxWidth: '1000px'
                }}>
                    {players.map((player) => (
                        <div
                            key={player.qr_code}
                            style={{
                                backgroundColor: '#1a1a1a',
                                border: '1px solid #333',
                                borderRadius: '8px',
                                padding: '15px',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.border = '1px solid #8b0000';
                                e.currentTarget.style.transform = 'scale(1.02)';
                                e.currentTarget.style.boxShadow = '0 0 15px rgba(139,0,0,0.3)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.border = '1px solid #333';
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.3)';
                            }}
                        >
                            {player.img && (
                                <img
                                    src={player.img.startsWith('http') || player.img.startsWith('data:') ? player.img : `data:image/jpeg;base64,${player.img}`}
                                    alt={player.titol}
                                    style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '4px', marginBottom: '15px', filter: 'sepia(30%) contrast(1.1)' }}
                                />
                            )}
                            <h3 style={{ margin: 0, fontSize: '1.5rem', textAlign: 'center', color: '#f4e4bc' }}>{player.titol}</h3>
                            {renderButtons(player)}
                        </div>
                    ))}
                </div>
            )}

            {showRules && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', boxSizing: 'border-box' }}>
                    <div style={{ backgroundColor: '#fffdf0', color: '#2c3e50', padding: '30px', borderRadius: '8px', maxWidth: '800px', width: '100%', maxHeight: '90vh', overflowY: 'auto', border: '2px solid #8b4513', boxShadow: '0 0 20px rgba(139,69,19,0.5)', fontFamily: '"Georgia", "Times New Roman", serif' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #8b4513', paddingBottom: '10px' }}>
                            <h2 style={{ margin: 0, color: '#8b0000', fontSize: '2rem' }}>Reglas del Juego</h2>
                            <button onClick={() => setShowRules(false)} style={{ background: 'none', border: 'none', fontSize: '2.5rem', cursor: 'pointer', color: '#8b0000', lineHeight: '1' }}>&times;</button>
                        </div>
                        
                        <h3 style={{ color: '#111', borderBottom: '1px dashed #ccc', paddingBottom: '5px' }}>🐺 El Bando de los Lobos (3 Jugadores)</h3>
                        <p style={{ fontSize: '1.1rem' }}>El objetivo de los lobos es acabar el día siendo mayoría o igualando en número a los inocentes.</p>
                        <ul style={{ lineHeight: '1.6', fontSize: '1.1rem', marginBottom: '25px' }}>
                            <li style={{ marginBottom: '10px' }}><strong>Lobo Alfa:</strong> Es el líder y el único que puede matar. Asesina exactamente a 2 personas por franja horaria comunicándoselo al Máster por privado. El Máster le comunicará quien es uno de sus lobos Lobo Saboteador pero el otro lo deberá descubrir.</li>
                            <li style={{ marginBottom: '10px' }}><strong>Lobo Buscador:</strong> Sabe que es lobo, pero no conoce ni al Alfa ni a su compañero. Su misión es encontrarlos. Una vez por franja, puede enviarle un mensaje al Máster preguntando: <em>"¿[Nombre de jugador] es el Alfa?"</em>. El Máster solamente dirá si es correcto o no. Cuando acierte se le comunicará al Alfa para que sepa quien es también.</li>
                            <li><strong>Lobo Saboteador:</strong> Tampoco conoce al Alfa de inicio pero el Alfa a él sí. Su misión es sembrar el caos. Una vez por franja, le envía al Máster el nombre de un jugador. Ese jugador sufrirá un "accidente" y su voto quedará anulado (valdrá cero) en la Asamblea de esa franja.</li>
                        </ul>

                        <h3 style={{ color: '#111', borderBottom: '1px dashed #ccc', paddingBottom: '5px', marginTop: '30px' }}>🛡️ Los Inocentes Especiales (4 Jugadores)</h3>
                        <p style={{ fontSize: '1.1rem' }}>El objetivo de los inocentes (los 7 normales y estos 4 con habilidades) es desenmascarar y ejecutar a los lobos en las Asambleas.</p>
                        <ul style={{ lineHeight: '1.6', fontSize: '1.1rem' }}>
                            <li style={{ marginBottom: '10px' }}><strong>El Protector:</strong> Al inicio de cada franja, le manda un mensaje al Máster indicando a quién va a proteger. Si el Lobo Alfa elige a esa persona como una de sus dos víctimas, el asesinato falla y el inocente sobrevive. Puede protegerse a sí mismo, pero nunca a la misma persona dos franjas seguidas.</li>
                            <li style={{ marginBottom: '10px' }}><strong>El Vidente:</strong> Una vez por franja, elige a un jugador y le pregunta al Máster por privado sobre su lealtad. El Máster solo puede responder <em>"Inocente"</em> o <em>"Lobo"</em> (no especifica qué tipo de lobo es ni qué habilidad tiene).</li>
                            <li style={{ marginBottom: '10px' }}><strong>El Vengador:</strong> Habilidad de un solo uso. Si es asesinado por el Lobo Alfa o linchado por error en una Asamblea, justo al revelarse su muerte, elige a cualquier jugador para llevárselo a la tumba inmediatamente.</li>
                            <li><strong>El Indulto:</strong> Habilidad de un solo uso por partida. Durante una Asamblea, si el pueblo vota ejecutar a alguien y cree que es un error, grita <em>"¡Indulto!"</em> y salva a ese jugador. En esa franja no muere nadie por votación.</li>
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CastronegroVotos;
